<template>
  <div id='contentTitle' @click='change'>
          <div class="title">{{title}}</div>
          <div class="titleEn" style='margin:10px 0'>{{titleEn}}</div>
        <el-collapse v-model="activeName" accordion @change='getActive'>
             <el-collapse-item v-for='(item,index) in List' :title="item.title" :name="index" :key='index'>
                 <div v-for='(item,index) in item.children' :key='item' class="contentDiv" :id="active == item.id ? 'collapseActive' : ''" :data-type='item.id' :data-title='item.title'>{{index+1}}.{{item.title}}</div>
             </el-collapse-item>
        </el-collapse>
  </div>
</template>
<script>
export default {
  name: "ContentNav",
  data() {
    return {
      loading:false,
      activeName:  165,
      active:""
    }
  },
  props: {
      List : {
          type:Array
       },
       title:{
           type:String,
           default:'实验室服务项目'
       },
       titleEn:{
           type : String,
           default:'Laboratory Services'
       }
  },
  mounted(){
    this.activeName = sessionStorage.getItem('type') - 1 
  },
  methods:{
     change(e){
       if(e.target.dataset.type){
        //  console.log(e.target.dataset.type)
         this.active = e.target.dataset.type
          this.$emit('increase',{id : e.target.dataset.type,title : e.target.dataset.title})
       }
     },
      getActive(e){
       this.activeName = e
      },
      selected(nameId){
        this.active = nameId;
      }
  }
}
</script>
<style scoped>
.title {
  font-size: 20px;
  /* color: #053b7b; */
  font-weight: 600;
  padding-left: 20px;
  padding-top:10px;
}
.titleEn {
  /* color: #00397c; */
  font-size: 18px;
  padding-left: 20px;
}
.contentDiv{
  height: 49px;
  line-height: 49px;
  word-break:keep-all;          
  white-space:nowrap;          
  overflow:hidden;       
  text-overflow:ellipsis;   
  cursor: pointer;
  border-bottom: 1px solid #EBEEF5;
  text-indent: 5px;
}
@media screen and (max-width: 750px) {
  .title,.titleEn{
    display:none;
  }
}
</style>